<template>
  <div class="footer-banner" :class="{'split': brochure && newsletter}">
    <div class="container">
      <div class="columns">
        <div class="column brochure" v-if="brochure">
          <h2>{{ brochure.title }}</h2>
          <p>{{brochure.description}}</p>
          <a class="button is-large is-primary" target="_blank" :href="($store.state.language === 'nl-NL' ? '/files/nl-NL/6769270.pdf' : '/files/en-GB/4fbc644b.pdf')">
            <span>{{brochure.button}}</span>
            <span class="icon is-small">
              <font-awesome-icon :icon="icons.right" />
            </span>
          </a>
        </div>
        <!-- <div class="column newsletter" v-if="newsletter"> -->
          <!-- <h2>{{newsletter.title}}</h2>
          <p>
            {{newsletter.description}}
          </p>
          <form action="/Subscribe" id="subscribe" method="post">
            <div class="field is-large">
              <input
                type="email"
                required="required"
                class="input"
                id="Emailaddress"
                name="Emailaddress"
                :placeholder="newsletter.placeholder"
              />
              <button
                class="button is-large is-primary"
                type="button"
                id="form-submit"
              >
                {{ newsletter.button }}
              </button>
            </div>
          </form> -->
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons'

export default {
  name: 'starFooter',
  props: {
    brochure: {
      type: Object,
      default: () => {}
    },
    newsletter: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      icons: {
        right: faChevronRight
      }
    }
  },
  components: {},
  computed: {}
}
</script>

<style lang="scss" scoped>
.footer-banner {
  position: relative;
  // background-color: $grey-bg;
  background-color: $main;
  // &.split{
  //   &:before {
  //     content: "";
  //     width: 50%;
  //     position: absolute;
  //     left: 0;
  //     top: 0;
  //     height: 100%;
  //     background-color: $main;
  //     z-index: 0;

  //     @media screen and (max-width: $bp-tablet - 1px) {
  //       width: 100%;
  //       height: 50%;
  //     }
  //   }
  // }
  > .container {
    z-index: 1;
    > .columns {
      .column {
        padding: 80px;
        @media screen and (max-width: $bp-widescreen - 1px) {
          padding: 80px 60px;
        }
        @media screen and (max-width: $bp-tablet - 1px) {
          padding: 80px 40px;
        }
        p {
          // height: 100px;
          font-size: 20px;
          color: $grey;
        }
        &.brochure {
          h2 {
            color: $white;
          }
          button {
            padding: 14px 30px 14px 30px;
            position: relative;
            border-radius: 40px;
            height: 55px;
          }
        }
        &.newsletter {
          .field {
            position: relative;
            .input {
              height: 55px;
              padding: 8px 150px 8px 14px;
              font-size: 18px;
              border-radius: 40px;
              border: 2px solid #d9d9d9;
              -webkit-box-shadow: none;
              box-shadow: none;
            }
            .button {
              position: absolute;
              right: 5px;
              top: 5px;
              z-index: 2;
              padding: 4px 30px;
              height: 45px;
              border-radius: 40px;
            }
            .error {
              position: absolute;
              left: 20px;
              top: 55px;
            }
            .success {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>
